@if(loading()) {
  <div class="fixed inset-0 w-full h-full bg-black opacity-10 z-[1102]"></div>
}
<router-outlet></router-outlet>

<p-toast position="top-center" [life]="2000" />